import { useEffect, useState } from "react"
import { Calendar } from "../../../components/calendar/calendar"
import { AdminHeader } from "../../../components/adminHeader/adminHeader"
import { usePopup } from "../../../components/popup/popup"
import { WeekDayPopup } from "./weekDayPopup"
import { useLocation, useParams } from "react-router"
import TableAPI from "../../../api/TableAPI"
import AdminAPI from "../../../api/AdminAPI"
import classNames from "classnames"
import qs from "qs"

import styles from "./tablePage.module.css"
import { Separator } from "../../../components/separator/separator"
import { Button } from "../../../components/button/button"
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate"

export const AdminTablePage = () => {
    const { search } = useLocation();
    const searchParams = qs.parse(search.replace("?", ""));

    const [date, setDate] = useState(new Date(searchParams.initialYear || new Date().getFullYear(), searchParams.initialMonth || new Date().getMonth(), 1));
    const [shifts, setShifts] = useState([]);

    const [Popup, open] = usePopup();

    const { cafeId } = useParams();
    const [maxCountEmp, setMaxCountEmp] = useState(1);

    const [isAdding, setIsAdding] = useState(false);

    useEffect(() => {
        if (cafeId === null) return;

        TableAPI
            .fetchAdminShiftsMonthly(cafeId, date.getFullYear(), date.getMonth() + 1)
            .then(res => setShifts(res))
            .catch(console.error);
    }, [cafeId, date]);

    useEffect(() => {
        if (!cafeId) return;

        AdminAPI
            .fetchCafeInfo(cafeId)
            .then(res => setMaxCountEmp(res.maxEmpCount))
            .catch(console.error);
    }, [cafeId]);

    const getShiftType = (shift) => {
        if (!shift) return "primary";
        const k = shift.countEmployees;
        return (k === 0) ? "primary" : (k < maxCountEmp) ? "mean" : "high";
    } 

    const [popupParams, setPopupParams] = useState({ date: new Date(), curShift: null });

    const [selectedDays, setSelectedDays] = useState([]);
    const onDayClicked = (date, curShift) => {
        if (isAdding) {
            setSelectedDays(prev => {
                if (prev.some(el => el.getTime() === date.getTime())) {
                    return prev.filter(d => d.getTime() !== date.getTime());
                } else {
                    return [...prev, date];
                }
            });
        } else {
            setPopupParams({ date, curShift });
            open();
        }
    }

    const navigate = useAnimatedNavigate();
    const onAddClick = () => {
        if (!isAdding) {
            setIsAdding(true);
        } else {
            const query = qs.stringify({
                dates: selectedDays.map(d => d.getTime()),
            });
            navigate(`/admin/${cafeId}/cafe/table/add?${query}`);
        }
    }

    return (
        <>
            <AdminHeader title="Табель" />

            <Calendar date={date} setDate={setDate} shifts={shifts} shiftType={getShiftType} onClick={onDayClicked} selectedDates={selectedDays} />

            <div className={styles.explanation_container}>
                <div className={classNames(styles.explanation_item, styles.high)}>Смена сформирована</div>
                <div className={classNames(styles.explanation_item, styles.mean)}>Смена сформирована не до конца</div>
                <div className={classNames(styles.explanation_item, styles.low)}>Смена еще не сформирована</div>
            </div>

            <Separator />

            <div className={classNames(styles.add_shifts_container, { [styles.active]: isAdding })}>
                <div style={{
                    overflow: "hidden",
                    minWidth: "0px",
                }}>
                    <Button
                        text="Отменить"
                        type="secondary"
                        onClick={() => {
                            setIsAdding(false);
                            setSelectedDays([]);
                        }}
                    />
                </div>
                <Button
                    text={isAdding ? "Подтвердить" : "Назначить смены" }
                    onClick={onAddClick}
                />
            </div>

            <Popup>
                <WeekDayPopup date={popupParams.date} shift={popupParams.curShift} setShift={(editedShift) => {
                    const newShifts = shifts.filter(el => el.shiftDate !== editedShift.shiftDate);
                    newShifts.push(editedShift);
                    setShifts(newShifts);
                }} />
            </Popup>
        </>
    )
}
